import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {StoreModule} from '@ngrx/store';
import { entityGrupoUsuarioFeatureKey, reducer } from './entity-grupo-usuario.reducer';


@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature(entityGrupoUsuarioFeatureKey, reducer),
  ],
})
export class EntityGrupoUsuarioModule {
}
